module.exports = __webpack_public_path__ + "img/angststoerungen1_960.bd200b21.png";